<template>
	<div class="w-full flex flex-col items-center h-screen p-4">
		<NuxtPage />
	</div>
</template>
